<section class="bg-banner pt-0 pb-0 banner-style03">
    <div class="hero-slider-wrapper">
        <img src="/assets/images/banner/advanced-skin-treatment.jpg" class="desktop-show" alt="Red Monk Wellness" />
        <img src="/assets/images/banner/advanced-skin-treatment-m.jpg" class="mobile-show" alt="Red Monk Wellness" />
    </div>
</section>


<!-- Advanced Skin Treatments & Peels start -->
<!-- ========================= -->

<section class="section-padding bg-blue">
    <div class="container">

        <div class="text-center">
            <h2 class="section-title"> <span>Advanced Skin Treatments & Peels</span></h2>
        </div>

<!-- Replace the whole  <div class="row g-4 justify-content-center"> ... </div>  (all the static cards) with this.
     Banner and heading stay as they are. -->

<div class="row g-4 justify-content-center">

    <div class="col-12 text-center text-muted" *ngIf="loading">Loading...</div>

    <div class="col-12 text-center text-muted" *ngIf="!loading && treatments.length === 0">
        No treatments available right now.
    </div>

    <div class="col-lg-3 col-md-4 col-sm-6" *ngFor="let t of treatments; trackBy: trackById">
        <div class="treatment-card2">
            <div class="card-glow"></div>

            <div class="treatment-content">
                <div class="treatment-icon">
                    <img [src]="imgUrl(t.Image)" [alt]="t.TreatmentName + ' Icon'" (error)="onImgError($event)">
                </div>

                <div class="treatment-info">
                    <h4 class="treatment-title">{{ t.TreatmentName }}</h4>

                    <p class="treatment-text" *ngIf="t.Advantages">
                        <span class="advantages">Advantages - </span>{{ t.Advantages }}
                    </p>
                </div>
            </div>
        </div>
    </div>

</div>

    </div>
</section>

<!-- ========================= -->